module.exports = {
	"articleTitle1": "South University area may see new student housing high-rise ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Espresso Royale",
	"articleLink1": "https://www.michigandaily.com/section/news/new-south-university-student-housing-project-works",
	"articleLink2": "https://www.michigandaily.com/section/business/espresso-royale-not-renewing-lease-main-street-location",
	"articleSnippet1": "Sep 6, 2016 ... The South University Avenue business district is preparing to ... Church Street \nand East University Avenue, though Espresso Royale and TCF ...",
	"articleSnippet2": "May 19, 2017 ... Espresso Royale will not be renewing its Main Street location lease for next ... \nSouth University area may see new student housing high-rise ...",
	"foodRecommendations": [],
	"articleTitle2": "Patrons disappointed with Main Street Espresso Royale closing in ...",
	"address": "1101 S University Ave #2, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2751,
		"lng": -83.7356
	},
	"totalMisc": 0,
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/espressoroyalesouthu.json
// module id = 875
// module chunks = 0